module.exports = "<div ng-if=\"$ctrl.conciergeUser\" class=\"header__concierge\"> <span>Concierge</span> <span ng-if=\"$ctrl.shouldShowAuthNetManagementLink()\" ng-click=\"$ctrl.manageAuthNet()\" class=\"header__concierge-auth-net-link\"> Manage Volusion Payments Authorize.net Settings </span> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/conciergeIndicator/conciergeIndicator.html
// module id = 1424
// module chunks = 28